import GenericError from "@/components/Shared/ErrorBoundary/GenericError"
import GlobalPageFooter from "@/components/Shared/GlobalPage/GlobalPageFooter"
import GlobalPageHeader from "@/components/Shared/GlobalPage/GlobalPageHeader"
import { footerUrl, headerUrl } from "@/constants"
import { aemAxiosInstance } from "@/constants/api"
import { filterBackEndJson } from "@/utils/helper"

/**
 *
 * @return {JSX.Element}
 */
export default function Custom500({ headertmp: header, footertmp: footer }) {
  return (
    <>
      {header ? <GlobalPageHeader header={header} /> : null}
      <GenericError />
      {footer ? <GlobalPageFooter footer={footer} /> : null}
    </>
  )
}

/**
 *
 * @return {Object}
 */
export async function getStaticProps() {
  const { data: header } = await aemAxiosInstance({
    url: `${headerUrl}.model.json`,
    method: "GET",
  })

  const { data: footer } = await aemAxiosInstance({
    url: `${footerUrl}.model.json`,
    method: "GET",
  })

  let headertmp
  if (header) headertmp = filterBackEndJson(header)
  let footertmp
  if (footer) footertmp = filterBackEndJson(footer)
  // Pass data to the page via props
  return {
    props: {
      headertmp,
      footertmp,
    },
  }
}
